import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { selectApplyApplicationData } from '../../store/slices/config/configSelectors';
import { ApplicationData } from 'src/types/flow';
import { RegistrantPage } from 'src/components/pages/RegistrantPage';
import { updatePermitApplicationData } from 'src/store/slices/apply/applySlice';

const ApplyRegistrant = () => {
  const data = (useSelector(selectApplyApplicationData) ??
    {}) as ApplicationData;
  return (
    <RegistrantPage
      allowRoleChange
      data={data}
      flow={FLOWS_ENUM.APPLY_LICENSE}
      updatePermitData={updatePermitApplicationData}
    />
  );
};

export default ApplyRegistrant;
